var React = require('react');

function BlindsRaised (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0,225.29H96V160.92H18.66Zm128-64.37v64.37H512l-18.66-64.37ZM493.34,64.37H128v64.37H512ZM0,128.74H96V64.37H18.66Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512,16.09V48.28a16,16,0,0,1-16,16.09H128v354a48,48,0,1,1-32,0v-354H16A16,16,0,0,1,0,48.28V16.09A16,16,0,0,1,16,0H496A16,16,0,0,1,512,16.09Z","className":"fa-primary","key":2})]);
}

BlindsRaised.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = BlindsRaised;

BlindsRaised.default = BlindsRaised;
